import styled from "styled-components";
import Colors from "src/general/constants/colors";
import BreakPoints from "src/general/constants/breakPoints";

type LinkProps = {
	change?: boolean;
};

type ListProps = {
	open?: boolean;
};
export const ListMobileNavigation = styled.ul<ListProps>`
	width: 100%;
	height: 100%;
	display: none;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	gap: 47px;
	position: absolute;
	padding: 0;
	top: 0;	
	left: 0;
	z-index: 9;
	background-color: ${Colors.GREY_OLD};
	transition: all 0.5s ease-in-out;
	transform: ${({ open = false }) => `translateX(${open ? 0 : "-100%"})`};
	box-sizing: border-box;

	@media (max-width: 1439px) {
		align-items: flex-start;
		padding-left: 40px;
		padding-top: 36px;
		gap: 24px;
		display: flex;
		z-index: 9999999;
		min-height: 100vh;
		position: fixed;
		-webkit-overflow-scrolling: touch;
		overflow-scrolling: touch;
		overflow-y: scroll;
	}
`;

export const ItemWrapper = styled.div<LinkProps>`
  display: flex;
  align-items: center;

  @media (max-width: ${BreakPoints.DESKTOPS}) {
    gap: 16px;
  }
}
`;

export const ItemNavigation = styled.li`
	position: relative;
	width: 100%;
`;

export const Item = styled.p<LinkProps>`
	cursor: pointer;
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	line-height: 16px;
	color: ${Colors.BLACK_OLD};
	padding: 10px 2px;
`;

export const Link = styled.a<LinkProps>`
	cursor: pointer;
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	line-height: 16px;
	color: ${Colors.BLACK_OLD};
	display: block;
	max-height: 40px;

	&:after {
		width: ${({ change = false }) => change && "100% !important"};
		content: "";
		position: absolute;
		height: 2px;
		background: ${Colors.VIOLET};
		bottom: -2px;
		left: 50%;
		transform: translate(-50%, 0px);
		transition: 0.3s;

		&:hover {
			width: 100%;
		}
	}
`;

export const MenuClose = styled.div`
	width: 100%;
	display: flex;
	justify-content: end;
	
	& svg {
			margin-right: 40px;
      cursor: pointer;
	}
`
